import { AdSystem } from '@/shared/enums';
import { getRandomParameters } from '@/shared/plugins/freewheel/helpers';

export default {
  data() {
    return {
      info: this.$services.resolve('info'),
      hideAdditionalLeaderBoard: false,
    };
  },
  watch: {
    'related.collection.records': function () {
      this.hideAdditionalLeaderBoard = !(this.related.collection.records?.length && this.episodes?.collection?.records?.length);
    },
    'episodes.collection.records': function () {
      this.hideAdditionalLeaderBoard = !(this.episodes.collection.records?.length && this.related?.collection?.records?.length);
    },
  },
  computed: {
    leaderboard() {
      if (!this.product || !this.info.additionalAd) {
        return;
      }

      const { freewheelDetailMobileScreenAdUnit, freewheelDetailScreenAdUnit } = this.info.additionalAd;

      return this.getLeaderboardData({ freewheelDetailMobileScreenAdUnit, freewheelDetailScreenAdUnit });
    },
  },
  methods: {
    getLeaderboardDimensions() {
      if (this.$window.isMobileView) {
        return { width: 300, height: 250, compatibleDimensions: '300,250|640,200|640,320|640,500|640,640' };
      }
      if (this.info.defaultTenant === 'AVOD_EE') {
        return { width: 1000, height: 200, compatibleDimensions: '1000,400|1000,200' };
      }
      return { width: 980, height: 200, compatibleDimensions: '980,200' };
    },
    getLeaderboardData({ freewheelDetailScreenAdUnit, freewheelDetailMobileScreenAdUnit, smartAdContainerForDetailScreen }) {
      const adSystem = this.info.adSystemForDetailScreenAd;

      let id = null;
      let slotParams = '';
      const autoLoad = true;

      if (adSystem === AdSystem.SMART_AD) {
        id = smartAdContainerForDetailScreen;
      }

      if (adSystem === AdSystem.FREEWHEEL) {
        id = this.$window.isSmallAdView ? freewheelDetailMobileScreenAdUnit : freewheelDetailScreenAdUnit;
        const dpr = window.devicePixelRatio;
        const { vprn, pvrn } = getRandomParameters();
        const { width, height, compatibleDimensions } = this.getLeaderboardDimensions();

        slotParams = `slid=${id}&vprn=${vprn}&pvrn=${pvrn}&ptgt=s&w=${width}&h=${height}&slau=${id}&_fw_dpr=${dpr}&cd=${compatibleDimensions}&tpcl=DISPLAY&flag=+cmpn+fcai`;
      }

      return {
        adSystem,
        id,
        autoLoad,
        slotParams,
      };
    },
  },
};
